import {
  GET_ADVERTISEMENTS_REQUEST,
  GET_ADVERTISEMENT_REQUEST,
  CREATE_ADVERTISEMENT_REQUEST,
  UPDATE_ADVERTISEMENT_REQUEST,
  DELETE_ADVERTISEMENT_REQUEST,
} from '../types/advertisements'

export function getAdvertisements(payload) {
  return {
    type: GET_ADVERTISEMENTS_REQUEST,
    payload,
  }
}

export function getAdvertisement(payload) {
  return {
    type: GET_ADVERTISEMENT_REQUEST,
    payload,
  }
}

export function createAdvertisement(payload) {
  return {
    type: CREATE_ADVERTISEMENT_REQUEST,
    payload,
  }
}

export function updateAdvertisement(payload) {
  return {
    type: UPDATE_ADVERTISEMENT_REQUEST,
    payload,
  }
}

export function deleteAdvertisement(payload) {
  return {
    type: DELETE_ADVERTISEMENT_REQUEST,
    payload,
  }
}
